import React from 'react';
import BillListScene from './BillListScene';

const BillListSceneContainer = (props) => <BillListScene location={props.location.query} />;

export default BillListSceneContainer;
